function MarketingContent({ companyName = "수집주체명", legacy = false }) {
  if (legacy) {
    return (
      <>
        <p><span>■ 마케팅 활용 및 수신 동의</span></p>
        <p>
          *이용자는 개인정보에 대해 마케팅 활용 동의 및 수신 거부할 권리가 있으나 동의를 거부할 경우 상품 및 이벤트 정보, 이벤트 참여, 상담 등에 제약이 발생할 수 있습니다.
        </p>
      </>
    );
  }
  return (
    <>
      <p><span>■ 마케팅 활용 및 수신 동의</span></p>
      <p>
        *이용자는 개인정보에 대해 마케팅 활용 동의 및 수신 거부할 권리가 있으나 동의를 거부할 경우 상품 및 이벤트 정보, 이벤트 참여, 상담 등에 제약이 발생할 수 있습니다.
      </p>
    </>
  );
}

export default MarketingContent;
